import * as React            from "react";
import {cs}                  from "@Common/react/chain-services";

export const FiveColumnSpecs = ({specificationFields, specFieldOnChange, next}) => cs(

    // This will make all original spec fields hidden. They will hold the values, & pass those to save function, but not be displayed.
    // Fields 06 & 07 will be displayed as normal fields.
    (({}, next) => next(specificationFields.forEach(field => {
        if (field.fieldKey === "field_6") {
            field.ordinal = 11;
            field.idDisplayStyle = 1;
        } else if (field.fieldKey === "field_7") {
            field.ordinal = 12;
            field.idDisplayStyle = 1;
        } else {
            field.idDisplayStyle = 6
        }
    }))),
    ["specFieldDuplicates", ({}, next) => next(specificationFields)],
    // tableFields will be used to display the fields in a 5 column configuration
    ["tableFields", ({}, next) => next([
        {
            ordinal: 0,
            idPrimary: null,
            fieldKey: "5-column-label-field",
            data: null,
            idDisplayStyle: 23,
            visible: true,
            displayLabel: "Labels",
            columnOneField: "field_11",
            columnTwoField: "field_12",
            columnThreeField: "field_13",
            columnFourField: "field_14",
            columnFiveField: "field_15",
            ignoreSave: true,
        },
        {
            ordinal: 1,
            idPrimary: null,
            fieldKey: "5-column-field_01",
            data: null,
            idDisplayStyle: 23,
            visible: true,
            displayLabel: "Data",
            columnOneField: "field_16",
            columnTwoField: "field_17",
            columnThreeField: "field_18",
            columnFourField: "field_19",
            columnFiveField: "field_20",
            ignoreSave: true,
        },
        {
            ordinal: 2,
            idPrimary: null,
            fieldKey: "5-column-field_02",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_21",
            columnTwoField: "field_22",
            columnThreeField: "field_23",
            columnFourField: "field_24",
            columnFiveField: "field_25",
            ignoreSave: true,
        },
        {
            ordinal: 3,
            idPrimary: null,
            fieldKey: "5-column-field_03",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_26",
            columnTwoField: "field_27",
            columnThreeField: "field_28",
            columnFourField: "field_29",
            columnFiveField: "field_30",
            ignoreSave: true,
        },
        {
            ordinal: 4,
            idPrimary: null,
            fieldKey: "5-column-field_04",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_31",
            columnTwoField: "field_32",
            columnThreeField: "field_33",
            columnFourField: "field_34",
            columnFiveField: "field_35",
            ignoreSave: true,
        },
        {
            ordinal: 5,
            idPrimary: null,
            fieldKey: "5-column-field_05",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_36",
            columnTwoField: "field_37",
            columnThreeField: "field_38",
            columnFourField: "field_39",
            columnFiveField: "field_40",
            ignoreSave: true,
        },
        {
            ordinal: 6,
            idPrimary: null,
            fieldKey: "5-column-field_06",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_41",
            columnTwoField: "field_42",
            columnThreeField: "field_43",
            columnFourField: "field_44",
            columnFiveField: "field_45",
            ignoreSave: true,
        },
        {
            ordinal: 7,
            idPrimary: null,
            fieldKey: "5-column-field_07",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_46",
            columnTwoField: "field_47",
            columnThreeField: "field_48",
            columnFourField: "field_49",
            columnFiveField: "field_50",
            ignoreSave: true,
        },
        {
            ordinal: 8,
            idPrimary: null,
            fieldKey: "5-column-field_08",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_51",
            columnTwoField: "field_52",
            columnThreeField: "field_53",
            columnFourField: "field_54",
            columnFiveField: "field_55",
            ignoreSave: true,
        },
        {
            ordinal: 9,
            idPrimary: null,
            fieldKey: "5-column-field_09",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_56",
            columnTwoField: "field_57",
            columnThreeField: "field_58",
            columnFourField: "field_59",
            columnFiveField: "field_60",
            ignoreSave: true,
        },
        {
            ordinal: 10,
            idPrimary: null,
            fieldKey: "5-column-field_10",
            data: null,
            idDisplayStyle: 22,
            visible: true,
            columnOneField: "field_61",
            columnTwoField: "field_62",
            columnThreeField: "field_63",
            columnFourField: "field_64",
            columnFiveField: "field_66",
            ignoreSave: true,
        },
    ])],
    (({tableFields, specFieldDuplicates}, next) => next(tableFields.forEach(field => {
        specFieldDuplicates.push(field);
    }))),
    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),


    ({specFieldDuplicates}) => next(specFieldDuplicates)
);